import {Col, Input, Row} from 'antd';
import {Rule} from 'antd/lib/form';
import React, {FC, Fragment, useMemo} from 'react';
import {useCompositorContext} from './../CompositorProvider';

import {JFieldBaseProps} from './../../models';
import {FormItem} from './../FormItem';
import {getValidationLabels, validators} from './../../validators';
import {DEFAULT_ROW_GUTTER} from './../../constants';
import {PasswordProps} from 'antd/lib/input';
import {InfoField} from '../InfoField';
import {EyeInvisibleOutlined, EyeTwoTone} from '@ant-design/icons';
import './JPassword.scss';

interface InputPassword extends Omit<PasswordProps, 'name'> {
    name: (string | number)[]
}

const InputPassword: FC<InputPassword> = props => (
    <Input.Password
        {...props}
        autoComplete={props.autoComplete}
        name={props.name.join('.')}
        iconRender={visible => visible ? (
            <EyeTwoTone aria-hidden={true}/>
        ) : (
            <EyeInvisibleOutlined aria-hidden={true}/>
        )
        }
    />
)
export const JPassword: FC<JFieldBaseProps> = props => {
    return (<>
        {!props?.confirmed || props.disabled ?
            <PasswordDefault {...props} />
            : <PasswordContainer {...props} />
        }
    </>)
}

const PasswordDefault: FC<JFieldBaseProps> = props => {
    const hasPrefix = props.description || props.infoFileURL
    return (
        <FormItem fieldProps={props} className={hasPrefix ? 'input-password-prefix-as-suffix' : ''}>
            <InputPassword
                prefix={
                    hasPrefix && (
                        <InfoField tooltipText={props.description} fileURL={props.infoFileURL}/>
                    )
                }
                autoComplete={props.autocomplete}
                name={props.name}
                disabled={props.disabled}
                placeholder={props?.placeholder}
                aria-describedby={props.validationMessage}
            />
        </FormItem>
    )
}

const PasswordContainer: FC<JFieldBaseProps> = props => {
    const {translate, confirmsColProps} = useCompositorContext();

    const translateLabels = useMemo(() => getValidationLabels(props.label, translate, {
        ignoreRequired: !props.mandatory
    }), [props.mandatory])

    const rules: Rule[] = useMemo(() => [validators.confirmed(props.name, translateLabels.noMatch)], [translateLabels]);


    return (
        <Fragment>
            <Row gutter={DEFAULT_ROW_GUTTER}>
                <Col {...confirmsColProps}>
                    <PasswordDefault {...props} />
                </Col>
                <Col {...confirmsColProps}>

                    <FormItem
                        fieldProps={props}
                        name={['formCompositorConfirms', ...props.name]}
                        rules={rules}
                    >
                        <InputPassword
                            autoComplete={props.autocomplete}
                            disabled={props.disabled}
                            name={[...props.name, 'confirm']}
                            placeholder={translateLabels.confirm}
                            aria-describedby={props.validationMessage}
                        />
                    </FormItem>
                </Col>
            </Row>
        </Fragment>
    )
}

